import { render, staticRenderFns } from "./AdministrativeDashboard.vue?vue&type=template&id=7a0236ce&scoped=true&"
import script from "./AdministrativeDashboard.vue?vue&type=script&lang=js&"
export * from "./AdministrativeDashboard.vue?vue&type=script&lang=js&"
import style0 from "./AdministrativeDashboard.vue?vue&type=style&index=0&id=7a0236ce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a0236ce",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VScrollYTransition } from 'vuetify/lib/components/transitions';
installComponents(component, {VAvatar,VBtn,VCard,VCardText,VDivider,VFlex,VIcon,VLayout,VProgressLinear,VScrollYTransition})
